var H = /* @__PURE__ */ ((e) => (e.QUERY = "query", e.SINGLE = "single", e.MULTIPLE = "multiple", e.CASCADE = "cascade", e))(H || {}), p = /* @__PURE__ */ ((e) => (e.SEARCH_RESULT = "search_result", e.REDIRECT = "redirect", e.SUGGESTION = "suggestion", e))(p || {}), h = /* @__PURE__ */ ((e) => (e.ASCENDING = "ASC", e.DESCENDING = "DESC", e))(h || {}), c = /* @__PURE__ */ ((e) => (e.CLASS_LEVELS = "klassenstufe", e.EDUCATIONAL_AREA = "bildungsbereich", e.FEDERAL_STATES = "bundesland", e.LICENSE_FORM = "lizenzform", e.LICENSE_FORM_SHORT = "lizenzform-kurz", e.PRODUCT_LINE = "produktlinie", e.PRODUCT_TYPES = "produktart", e.SCHOOL_SUBJECTS = "fach", e.SCHOOL_TYPES = "schulform", e.SERIES_TITLE = "reihe", e.VOLUME_TITLE = "band", e.TARGET_GROUP_NAME = "zielgruppe", e.DISTRIBUTIONSFORM = "digital", e.GER_NIVEAU = "ger-niveau", e.PRODUCT_TYPE_SEMANTIC = "product-type-semantic", e))(c || {}), R = /* @__PURE__ */ ((e) => (e.SERIES_AND_VOLUME = "relevant-fuer-reihe-band", e.SERIES_AND_EDITION_AND_VOLUME = "relevant-fuer-reihe-reihenausgabe-band", e.EDUCATIONAL_AREA_AND_SCHOOL_TYPE = "bildungsbereich-schulform", e))(R || {}), E = /* @__PURE__ */ ((e) => (e.ADDITIONAL_LICENSES = "additional_licenses", e.COVER_URI = "cover-uri", e.DATE_EXPECTED_PUBLICATION = "date-expected-publication", e.DATE_PUBLICATION = "date-publication", e.DEMO_EXISTS = "demo_exists", e.DETAIL_URI = "detail-uri", e.DISPLAY_TITLE_HEADING = "display-title-heading", e.DISPLAY_TITLE_INFO = "display-title-info", e.DISPLAY_TITLE_SUBHEADING = "display-title-subheading", e.IDENTIFIER = "identifier", e.IS_ESTIMATED_PRICE = "is-estimated-price", e.IS_FREE_IN_ABO = "is-free-in-abo", e.IS_NEW = "is-new", e.ISBN = "isbn", e.LICENSE_FORM = "license-form", e.LICENSE_FORM_SHORT = "license-form-short", e.PRICE_EUR = "price-eur", e.PUBLISHING_HOUSE = "publishing-house", e.SCHOOL_SUBJECTS = "school_subjects", e.SUPPORTED_BY_SERIES = "supported_by_series", e.TARGET_GROUP_NAME = "target_group_name", e.DISTRIBUTIONSFORM = "distributionsform", e.GER_NIVEAU = "ger_niveau", e.HIGHEST_QUANTITY_SCALE_PRICE = "highest_quantity_scale_price", e))(E || {}), B = /* @__PURE__ */ ((e) => (e.QUERY = "query", e))(B || {}), I = /* @__PURE__ */ ((e) => (e.CLASS_LEVELS = "class-levels", e.EDUCATIONAL_AREA = "educational-areas", e.FEDERAL_STATES = "federal-states", e.LICENSE_FORM = "license-form", e.LICENSE_FORM_SHORT = "license-form-short", e.PRODUCT_LINE = "product-line", e.PRODUCT_TYPES = "producttypes", e.SCHOOL_SUBJECTS = "school-subjects", e.SCHOOL_TYPES = "school-types", e.SERIES_TITLE = "series-title", e.VOLUME_TITLE = "volume-title", e.TARGET_GROUP_NAME = "target-group-name", e.DISTRIBUTIONSFORM = "distributionsform", e.GER_NIVEAU = "ger-niveau", e.PRODUCT_TYPE_SEMANTIC = "product-type-semantic", e))(I || {}), d = /* @__PURE__ */ ((e) => (e.SERIES_AND_VOLUME = "path-sv", e.SERIES_AND_EDITION_AND_VOLUME = "path-ssv", e.EDUCATIONAL_AREA_AND_SCHOOL_TYPE = "path-es", e))(d || {}), o = /* @__PURE__ */ ((e) => (e.ADDITIONAL_LICENSES = "additional_licenses", e.COVER_URI = "cover_uri", e.DATE_EXPECTED_PUBLICATION = "date_expected_publication_raw", e.DATE_PUBLICATION = "date_publication_raw", e.DEMO_EXISTS = "demo_exists", e.DETAIL_URI = "detail_uri", e.DISPLAY_TITLE_HEADING = "display_title_heading", e.DISPLAY_TITLE_INFO = "display_title_info", e.DISPLAY_TITLE_INFO_1 = "display_title_info_1", e.DISPLAY_TITLE_INFO_2 = "display_title_info_2", e.DISPLAY_TITLE_SUBHEADING = "display_title_subheading", e.DISPLAY_TITLE_SUBHEADING_1 = "display_title_subheading_1", e.DISPLAY_TITLE_SUBHEADING_2 = "display_title_subheading_2", e.HIGHEST_QUANTITY_SCALE_PRICE = "highest_quantity_scale_price", e.IS_ESTIMATED_PRICE = "is_estimated_price", e.IS_FREE_IN_ABO = "is_free_in_abo", e.IS_NEW = "is_new", e.ISBN = "isbn", e.LICENSE_FORM = "license_form", e.LICENSE_FORM_SHORT = "license_form_short", e.LICENSE_GROUPING_ID = "license_grouping_id", e.LICENSE_GROUPING_RANK = "license_grouping_rank_current", e.PRICE_EUR = "price_eur", e.PUBLISHING_HOUSE = "publishing_house", e.SCHOOL_SUBJECTS = "school_subjects", e.SUGGESTION_HEADING = "suggestion_heading", e.SUPPORTED_BY_SERIES = "supported_by_series", e))(o || {}), D = /* @__PURE__ */ ((e) => (e.PRODUCTS = "products", e.QUERIES = "queries", e))(D || {}), m = /* @__PURE__ */ ((e) => (e.COLLECTION = "COLLECTION", e.TREE = "TREE", e))(m || {}), S = /* @__PURE__ */ ((e) => (e.CLASS_LEVELS = "class_levels", e.EDUCATIONAL_AREA = "educational_areas", e.FEDERAL_STATES = "federal_states", e.LICENSE_FORM = "license_form", e.LICENSE_FORM_SHORT = "license_form_short", e.PRODUCT_LINE = "product_line", e.PRODUCT_TYPES = "product_type_name", e.SCHOOL_SUBJECTS = "school_subjects", e.SCHOOL_TYPES = "school_types", e.SERIES_TITLE = "series_title", e.VOLUME_TITLE = "volume_title", e.TARGET_GROUP_NAME = "target_group_name", e.DISTRIBUTIONSFORM = "distributionsform", e.GER_NIVEAU = "ger_niveau", e.PRODUCT_TYPE_SEMANTIC = "product_type_semantic", e))(S || {}), L = /* @__PURE__ */ ((e) => (e.EDUCATIONAL_AREA_AND_SCHOOL_TYPE = "Bereich/Schulform", e.SERIES_AND_EDITION_AND_VOLUME = "Lehrwerk", e))(L || {});
const w = {
  [S.CLASS_LEVELS]: I.CLASS_LEVELS,
  [S.EDUCATIONAL_AREA]: I.EDUCATIONAL_AREA,
  [S.FEDERAL_STATES]: I.FEDERAL_STATES,
  [S.LICENSE_FORM]: I.LICENSE_FORM,
  [S.LICENSE_FORM_SHORT]: I.LICENSE_FORM_SHORT,
  [S.PRODUCT_LINE]: I.PRODUCT_LINE,
  [S.PRODUCT_TYPES]: I.PRODUCT_TYPES,
  [S.SCHOOL_SUBJECTS]: I.SCHOOL_SUBJECTS,
  [S.SCHOOL_TYPES]: I.SCHOOL_TYPES,
  [S.SERIES_TITLE]: I.SERIES_TITLE,
  [S.VOLUME_TITLE]: I.VOLUME_TITLE,
  [S.TARGET_GROUP_NAME]: I.TARGET_GROUP_NAME,
  [S.DISTRIBUTIONSFORM]: I.DISTRIBUTIONSFORM,
  [S.GER_NIVEAU]: I.GER_NIVEAU,
  [S.PRODUCT_TYPE_SEMANTIC]: I.PRODUCT_TYPE_SEMANTIC
}, x = (e) => {
  const t = w[e.name];
  return t ? {
    [t]: e.values.map(
      (r) => ({
        value: r.value,
        count: r.count,
        label: r.name
      })
    )
  } : {};
}, k = (e) => e.reduce(
  (t, r) => ({
    ...t,
    ...x(r)
  }),
  {}
), Z = {
  [o.ADDITIONAL_LICENSES]: E.ADDITIONAL_LICENSES,
  [o.COVER_URI]: E.COVER_URI,
  [o.DATE_EXPECTED_PUBLICATION]: E.DATE_EXPECTED_PUBLICATION,
  [o.DATE_PUBLICATION]: E.DATE_PUBLICATION,
  [o.DEMO_EXISTS]: E.DEMO_EXISTS,
  [o.DETAIL_URI]: E.DETAIL_URI,
  [o.DISPLAY_TITLE_HEADING]: E.DISPLAY_TITLE_HEADING,
  [o.DISPLAY_TITLE_INFO]: E.DISPLAY_TITLE_INFO,
  [o.DISPLAY_TITLE_SUBHEADING]: E.DISPLAY_TITLE_SUBHEADING,
  [o.IS_ESTIMATED_PRICE]: E.IS_ESTIMATED_PRICE,
  [o.IS_FREE_IN_ABO]: E.IS_FREE_IN_ABO,
  [o.IS_NEW]: E.IS_NEW,
  [o.ISBN]: E.ISBN,
  [o.LICENSE_FORM]: E.LICENSE_FORM,
  [o.LICENSE_FORM_SHORT]: E.LICENSE_FORM_SHORT,
  [o.PRICE_EUR]: E.PRICE_EUR,
  [o.PUBLISHING_HOUSE]: E.PUBLISHING_HOUSE,
  [o.SCHOOL_SUBJECTS]: E.SCHOOL_SUBJECTS,
  [o.SUPPORTED_BY_SERIES]: E.SUPPORTED_BY_SERIES,
  [o.HIGHEST_QUANTITY_SCALE_PRICE]: E.HIGHEST_QUANTITY_SCALE_PRICE
}, M = (e) => Number(e) || 0, f = (e) => typeof e == "string" || e instanceof String ? e !== "" && e.toLocaleLowerCase() !== "false" : !!e, U = (e) => Array.isArray(e) ? e : e || e === "" || e === 0 ? [e] : [], v = (e) => typeof e == "object" && e !== null && typeof e.amount == "number" && typeof e.gross_eurocent == "number", j = (e) => {
  if (v(e))
    return e;
  if (!(typeof e != "string" || e === ""))
    try {
      const t = JSON.parse(e);
      return v(t) ? t : void 0;
    } catch {
      return;
    }
}, Q = {
  [o.ADDITIONAL_LICENSES]: U,
  [o.DISPLAY_TITLE_INFO]: U,
  [o.DISPLAY_TITLE_SUBHEADING]: U,
  [o.IS_ESTIMATED_PRICE]: f,
  [o.IS_FREE_IN_ABO]: f,
  [o.IS_NEW]: f,
  [o.DEMO_EXISTS]: f,
  [o.PRICE_EUR]: M,
  [o.SCHOOL_SUBJECTS]: U,
  [o.SUPPORTED_BY_SERIES]: U,
  [o.HIGHEST_QUANTITY_SCALE_PRICE]: j
}, J = (e, t) => {
  const r = Q[t];
  return r && typeof r == "function" ? r(e) : e;
}, N = (e) => e != null, z = (e) => N(e) && e !== !1 && e !== 0 && e !== "", X = (e) => e.filterType === H.QUERY, q = (e) => e.type === m.COLLECTION, W = (e) => e.type === m.TREE, $ = (e) => Object.values(c).indexOf(e) !== -1, G = (e) => Object.values(R).indexOf(
  e
) !== -1, K = (e) => Object.values(L).indexOf(e) !== -1, ee = (e) => e.type === D.QUERIES, te = (e) => Object.prototype.hasOwnProperty.call(e, "redirect"), re = {
  // [ZOOVU_CASCADE_NAME.SERIES_AND_VOLUME]: SOLR_CASCADE_NAME.SERIES_AND_VOLUME,
  [L.SERIES_AND_EDITION_AND_VOLUME]: d.SERIES_AND_EDITION_AND_VOLUME,
  [L.EDUCATIONAL_AREA_AND_SCHOOL_TYPE]: d.EDUCATIONAL_AREA_AND_SCHOOL_TYPE
}, C = {
  ZOOVU: "/",
  SAL: ">"
}, ne = "ROOT", se = {
  [c.CLASS_LEVELS]: S.CLASS_LEVELS,
  [c.EDUCATIONAL_AREA]: S.EDUCATIONAL_AREA,
  [c.FEDERAL_STATES]: S.FEDERAL_STATES,
  [c.LICENSE_FORM]: S.LICENSE_FORM,
  [c.LICENSE_FORM_SHORT]: S.LICENSE_FORM_SHORT,
  [c.PRODUCT_LINE]: S.PRODUCT_LINE,
  [c.PRODUCT_TYPES]: S.PRODUCT_TYPES,
  [c.SCHOOL_SUBJECTS]: S.SCHOOL_SUBJECTS,
  [c.SCHOOL_TYPES]: S.SCHOOL_TYPES,
  [c.SERIES_TITLE]: S.SERIES_TITLE,
  [c.VOLUME_TITLE]: S.VOLUME_TITLE,
  [c.TARGET_GROUP_NAME]: S.TARGET_GROUP_NAME,
  [c.DISTRIBUTIONSFORM]: S.DISTRIBUTIONSFORM,
  [c.GER_NIVEAU]: S.GER_NIVEAU,
  [c.PRODUCT_TYPE_SEMANTIC]: S.PRODUCT_TYPE_SEMANTIC
}, P = {
  [R.EDUCATIONAL_AREA_AND_SCHOOL_TYPE]: L.EDUCATIONAL_AREA_AND_SCHOOL_TYPE,
  [R.SERIES_AND_EDITION_AND_VOLUME]: L.SERIES_AND_EDITION_AND_VOLUME
}, oe = (e) => {
  const t = se[e];
  if (t !== void 0)
    return t;
}, Se = (e) => {
  const t = P[e];
  if (t !== void 0)
    return t;
}, ie = (e) => {
  const t = Object.keys(P).find(
    (r) => P[r] === e
  );
  if (t !== void 0)
    return t;
}, Ee = (e) => e.reduce((t, r) => [...t, ...r.children], []), A = (e, { prefix: t = [], filterValues: r = [], skipLevel: n } = {
  prefix: [],
  filterValues: []
}, s = 0) => {
  const [i, ...u] = r, { current: _, next: l } = e.reduce(
    (O, a) => {
      const g = i === a.name ? [
        {
          values: n && n === s ? Ee(a.children) : a.children,
          prefix: [...t, a.name],
          filterValues: u
        }
      ] : [];
      return {
        current: [
          ...O.current,
          {
            value: [...t, a.name].join(C.SAL),
            count: a.count
          }
        ],
        next: [...O.next, ...g]
      };
    },
    {
      current: [],
      next: []
    }
  ), T = (l == null ? void 0 : l.length) > 0 ? l.reduce(
    (O, { values: a, prefix: g, filterValues: Y }) => {
      if (a.length > 0) {
        const F = A(
          a,
          {
            prefix: g,
            filterValues: Y
          },
          s + 1
        );
        return [...O, ...F];
      }
      return O;
    },
    []
  ) : [];
  return [_, ...T];
}, ue = (e, { filterValues: t } = {}) => {
  var u;
  const r = K(
    e.name
  ) ? e.name : void 0, n = r ? re[r] : e.name, s = r ? ie(r) : void 0;
  if (s === R.SERIES_AND_EDITION_AND_VOLUME) {
    const _ = t && t[R.SERIES_AND_EDITION_AND_VOLUME] ? t[R.SERIES_AND_EDITION_AND_VOLUME].split(
      C.SAL
    ) : [], l = t && t[R.SERIES_AND_VOLUME] ? t[R.SERIES_AND_VOLUME].split(
      C.SAL
    ) : [], T = A(
      e.children,
      {
        filterValues: _
      }
    ), O = A(
      e.children,
      {
        filterValues: l,
        skipLevel: 1
      }
    );
    return {
      [d.SERIES_AND_EDITION_AND_VOLUME]: T,
      [d.SERIES_AND_VOLUME]: O
    };
  }
  const i = s && t ? (u = t[s]) == null ? void 0 : u.split(C.SAL) : [];
  return {
    [n]: A(e.children, {
      filterValues: i
    })
  };
}, _e = (e, t = {}) => e.categories.reduce(
  (n, s) => {
    const i = ue(s, {
      filterValues: t
    });
    return {
      ...n,
      ...i
    };
  },
  {}
), ce = (e) => ({
  ...e,
  [E.DISPLAY_TITLE_INFO]: [
    e[o.DISPLAY_TITLE_INFO_1],
    e[o.DISPLAY_TITLE_INFO_2]
  ].filter(N),
  [E.DISPLAY_TITLE_SUBHEADING]: [
    e[o.DISPLAY_TITLE_SUBHEADING_1],
    e[o.DISPLAY_TITLE_SUBHEADING_2]
  ].filter(N)
}), b = (e) => (e == null ? void 0 : e.parsedValue) !== void 0 ? e.parsedValue : (e == null ? void 0 : e.values) !== void 0 ? e.values : e == null ? void 0 : e.value, y = (e, t) => {
  const r = e.dataPoints.find(
    (n) => n.key === t
  );
  if (r)
    return b(r);
}, Ie = (e, t) => e.find((r) => {
  const n = y(
    r,
    o.LICENSE_FORM
  );
  if (!(n === void 0 || n === ""))
    return Array.isArray(t) ? t.indexOf(n) > -1 : n !== void 0 && n === t;
}), ae = (e) => e.reduce((t, r, n) => {
  if (n === 0)
    return t;
  const s = y(
    t,
    o.LICENSE_GROUPING_RANK
  ), i = y(
    r,
    o.LICENSE_GROUPING_RANK
  );
  return i === void 0 || s !== void 0 && s < i ? t : r;
}, e[0]), le = (e, t) => {
  if (e.length === 1)
    return e[0];
  if (t !== void 0 && t !== "") {
    const r = Ie(e, t);
    if (r !== void 0)
      return r;
  }
  return ae(e);
}, Oe = (e) => {
  const t = e.dataPoints.reduce(
    (r, n) => {
      const s = Z[n.key] || n.key;
      return {
        ...r,
        [s]: J(b(n), n.key)
      };
    },
    {
      [E.DETAIL_URI]: "",
      [E.PRICE_EUR]: 0,
      [E.IDENTIFIER]: e.identifier
    }
  );
  return ce(t);
}, Te = (e, {
  licenseFormFilterValue: t,
  facetFilterValues: r
} = {}) => {
  const n = e.searchResults.find(
    (T) => T.type === D.PRODUCTS
  );
  if (n === void 0)
    throw new Error("The server returned an invalid response");
  const s = n.results.map((T) => {
    const O = le(
      T,
      t
    );
    return Oe(O);
  }), i = e.filterOptions.filter(
    q
  ), u = e.filterOptions.find(W), _ = k(i), l = u ? _e(u, r) : {};
  return {
    count: (n == null ? void 0 : n.totalResults) || 0,
    records: s,
    facets: _,
    facetpaths: l
  };
}, Re = (e) => e ? h.DESCENDING : h.ASCENDING, Ce = (e) => ({
  key: e.field,
  direction: Re(e.isDescending)
}), Le = (e) => ({ value: e }), Ue = (e, t) => {
  const r = t.split(C.SAL);
  return {
    value: [ne, e, ...r].join(C.ZOOVU)
  };
}, pe = (e, t) => {
  var n, s;
  if (X(t) || ((n = t.values) == null ? void 0 : n.length) === 0)
    return null;
  const r = oe(e) || e;
  return ((s = t.values) == null ? void 0 : s.length) > 0 ? {
    name: r,
    type: D.PRODUCTS,
    values: t.values.map(
      Le
    )
  } : null;
}, de = (e, t) => {
  var n;
  if (((n = t.values) == null ? void 0 : n.length) === 0)
    return null;
  const r = Se(e) || e;
  return t.values.map(
    (s) => Ue(r, s)
  );
}, De = (e) => {
  var n;
  const t = Object.keys(e).reduce(
    (s, i) => {
      if ($(i)) {
        const u = e[i], _ = u ? pe(i, u) : null;
        return _ ? { ...s, filters: [...s.filters, _] } : s;
      }
      if (G(i)) {
        const u = e[i], _ = u ? de(i, u) : null;
        return _ && _.length > 0 ? {
          ...s,
          categoryValues: [...s.categoryValues, ..._]
        } : s;
      }
      return s;
    },
    {
      filters: [],
      categoryValues: []
    }
  ), r = ((n = t == null ? void 0 : t.categoryValues) == null ? void 0 : n.length) > 0 ? [
    {
      name: "Kategorie",
      type: D.PRODUCTS,
      values: t.categoryValues
    }
  ] : [];
  return [...t.filters, ...r];
}, fe = (e) => {
  const r = e.searchResults.find(ee);
  return {
    suggestions: ((r == null ? void 0 : r.results) || []).map((i) => ({
      term: i.name
    })).filter(N)
  };
}, V = async (e, t = 2e3) => {
  const r = new AbortController();
  setTimeout(() => r.abort(), t);
  try {
    return await fetch(e.toString(), {
      signal: r.signal
    });
  } catch (n) {
    throw n instanceof Error && n.name === "AbortError" ? new Error("The server took to long to respond.") : Error;
  }
}, Ae = (e) => {
  const t = De(e);
  return JSON.stringify(t);
}, Ne = (e) => {
  const t = Ce(e);
  return JSON.stringify(t);
}, ge = (e) => {
  var r;
  const t = e[c.LICENSE_FORM];
  return (r = t == null ? void 0 : t.values) != null && r.length ? t.values[0] : "";
}, he = (e) => e ? Object.keys(e).reduce((t, r) => {
  var n;
  if (G(r)) {
    const s = (n = e[r]) == null ? void 0 : n.values;
    return s && s.length > 0 ? {
      ...t,
      [r]: s[0]
    } : t;
  }
  return t;
}, {}) : {}, Pe = (e, { limit: t = 20, offset: r = 0, filters: n, sortOptions: s, rankingStrategy: i }) => {
  var O;
  const u = new URL(e), _ = n && ((O = n[B.QUERY]) == null ? void 0 : O.values[0]) || "*", l = n ? Ae(n) : "", T = s && s.length > 0 ? s.map((a) => Ne(a)) : "";
  return u.searchParams.append("query", _.trim()), u.searchParams.append("limit", t.toString()), u.searchParams.append("offset", r.toString()), l !== "" && u.searchParams.append("filters", l), T && T.length > 0 && T.forEach((a) => {
    a !== "" && u.searchParams.append("sortComplex", a);
  }), i != null && i.id && i.id !== "" && u.searchParams.append(
    "sortComplex",
    JSON.stringify({
      rankingStrategyId: i.id,
      type: "Strategy"
    })
  ), u;
}, ye = (e, t = "") => {
  const r = new URL(e);
  return t !== "" && r.searchParams.append("query", t.trim()), r;
}, me = (e, t) => {
  if (te(e))
    return { ...e, type: p.REDIRECT };
  const r = t ? ge(t) : "", n = t ? he(t) : {};
  return {
    ...Te(e, {
      licenseFormFilterValue: r,
      facetFilterValues: n
    }),
    type: p.SEARCH_RESULT
  };
}, ve = ({
  projectId: e,
  timeout: t = 2e3
}) => {
  const r = `https://api-v3.semknox.com/search?projectId=${e}`, n = `https://api-v3.semknox.com/search/suggestions?projectId=${e}`;
  return {
    fetchResults: async (s) => {
      const i = Pe(r, s), _ = await (await V(i, t)).json();
      return me(_, s.filters);
    },
    fetchSuggestions: async (s) => {
      if (!z(s))
        return { suggestions: [], type: p.SUGGESTION };
      const i = ye(n, s), _ = await (await V(i, t)).json();
      return {
        ...fe(_),
        type: p.SUGGESTION
      };
    }
  };
};
export {
  ve as default
};
